/**
 * splitPhone — Phase 43.2
 *
 * Se l'utente ha salvato un numero comprensivo di prefisso (es. "+41791234567"),
 * separa prefisso + numero nazionale così che il PhonePrefixInput non mostri
 * due volte il prefisso (uno nel selettore, uno dentro al campo numero).
 *
 * Strategia:
 *  - se la stringa NON inizia con "+", restituiamo {prefix: defaultPrefix, number: raw}
 *  - se inizia con "+", proviamo a fare parse con libphonenumber-js:
 *      • se valida → ritorniamo callingCode + significant national number
 *      • altrimenti → fallback: stripping il prefisso passato come default
 */
import { parsePhoneNumberFromString, getCountryCallingCode, isSupportedCountry } from "libphonenumber-js";

export function splitPhone(raw, defaultPrefix = "+41") {
  const value = String(raw || "").trim();
  if (!value) return { prefix: defaultPrefix, number: "" };

  if (!value.startsWith("+")) {
    return { prefix: defaultPrefix, number: value };
  }

  try {
    const parsed = parsePhoneNumberFromString(value.replace(/\s+/g, ""));
    if (parsed && parsed.countryCallingCode) {
      return {
        prefix: `+${parsed.countryCallingCode}`,
        number: parsed.nationalNumber || "",
      };
    }
  } catch { /* fall through */ }

  // Fallback: stripping prefisso noto
  if (defaultPrefix && value.startsWith(defaultPrefix)) {
    return { prefix: defaultPrefix, number: value.slice(defaultPrefix.length).trim() };
  }
  // Ultimo fallback: prova prefissi comuni a 2-4 char
  const m = value.match(/^\+(\d{1,3})(.*)$/);
  if (m) {
    return { prefix: `+${m[1]}`, number: m[2].trim() };
  }
  return { prefix: defaultPrefix, number: value };
}

/**
 * normalizePrefix — assicura un prefisso valido E.164 (+XX).
 */
export function normalizePrefix(p, fallback = "+41") {
  const v = String(p || "").trim();
  if (/^\+\d{1,4}$/.test(v)) return v;
  return fallback;
}

// no-op export per evitare warning su unused import country helpers in futuro
export { getCountryCallingCode, isSupportedCountry };
